import $ from 'jquery';
import 'select2';
import haversine from 'haversine-distance';

$.fn.select2.amd.define('select2/data/customAdapter',
    ['select2/data/array', 'select2/utils'],
    function (ArrayAdapter, Utils) {
        function CustomDataAdapter ($element, options) {
            CustomDataAdapter.__super__.constructor.call(this, $element, options);
        }
        Utils.Extend(CustomDataAdapter, ArrayAdapter);
        CustomDataAdapter.prototype.updateOptions = function (data) {
            this.$element.find('option').remove(); // remove all options
            this.addOptions(this.convertToOptions(data));
        }
        return CustomDataAdapter;
    }
);

const select2Pos = {
    build() {
        var $select = $('.pos-select');
        var noResults = $select.attr('data-noresults');
        var placeholder = $select.attr('data-placeholder');

        var customAdapter = $.fn.select2.amd.require('select2/data/customAdapter');

        var data = [{
            id: 'none',
            text: placeholder,
            html: placeholder,
            lat: 0,
            lon: 0,
            distance: 0,
            distanceHtml: ''
        }];
        var selected = '';
        $select.find('.posItem').each(function (index, item) {
            var $item = $(item);
            var newItem = {
                id: $item.attr('data-pos-id'),
                text: $item.attr('data-pos-name'),
                html: $item.html(),
                lat: $item.attr('data-pos-lat'),
                lon: $item.attr('data-pos-lon'),
                distance: 0,
                distanceHtml: ''
            };
            data.push(newItem);
            if($item.hasClass('selected')) {
                selected = newItem.id;
            }
        });
        var select = $select.find('.js-select2Pos').select2({
            width: '100%',
            minimumResultsForSearch: 2,
            "language": {
                "noResults": function () {
                    return noResults;
                }
            },
            dataAdapter: customAdapter,
            data: data,
            escapeMarkup: function(markup) {
                return markup;
            },
            templateResult: function(data) {
                return '<div data-cy="posSelectID_'+data.id+'"><strong>'+data.text+data.distanceHtml+'</strong><br>' + data.html + '</div>';
            },
            templateSelection: function(data) {
                return data.text+data.distanceHtml;
            },
            matcher: function(params, data) {
                if ($.trim(params.term) === '') {
                    return data;
                }

                if (typeof data.text === 'undefined') {
                    return null;
                }

                if (data.html.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
                    return $.extend({}, data, true);
                }
                
                return null;
            }
        });
        select.val(selected);
        select.trigger('change');

        $('.js-get-geolocation').on('click', function (e) {
            e.preventDefault();
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        var myLocation = {latitude: position.coords.latitude, longitude: position.coords.longitude};
                        for (var i=1; i<data.length; i++) {
                            var store = data[i];
                            var storeLocation = {latitude: store.lat, longitude: store.lon};
                            store.distance = haversine(myLocation, storeLocation)/1000;
                                store.distanceHtml = ' (' + store.distance.toFixed(1) + 'km)';
                        }
                        data.sort((a,b) => (a.distance > b.distance) ? 1 : ((b.distance > a.distance) ? -1 : 0));
                        select.data('select2').dataAdapter.updateOptions(data);
                        select.val(data[1].id);
                        select.trigger('change');
                    },
                    function (error) {
                        switch(error.code) {
                            case error.PERMISSION_DENIED:
                                console.error = "User denied the request for Geolocation.";
                                break;
                            case error.POSITION_UNAVAILABLE:
                                console.error = "Location information is unavailable.";
                                break;
                            case error.TIMEOUT:
                                console.error = "The request to get user location timed out.";
                                break;
                            case error.UNKNOWN_ERROR:
                                console.error = "An unknown error occurred.";
                                break;
                        }
                    });
            } else {
                console.log = "Geolocation is not supported by this browser.";
            }
        });

        $select.find('.js-select2Pos').on('change', function () {
            if($('.js-btn-update-pos').length > 0) {
                $select.closest('form').find('.js-btn-update-pos').prop('disabled', false);
            }
        });
    }
};

// DOM ready
$(() => {
    select2Pos.build();
});

export default select2Pos;
